import { Notify } from "vant";

let timer;

export default {
  data() {
    return {
      sex: "",
      name: "",
      phone: "",
      shopId: "",
      captcha: "",
      captchaCount: 60,
      captchaLoading: false,
      birthday: "",
      birthday2: "",
      minBirthday: new Date(1970, 0, 1),
      maxBirthday: new Date(),
      phoneFocus: false,
      regVipDisable: true,
      dateFormat: this.$dateFormat,
      birthdayVisible: false
    };
  },

  created() {
    const { s } = this.$route.query;
    this.shopId = s;
    this.$store.dispatch("vip/getShop", { shop_id: this.shopId }).then((data = {}) => {
      const { shopName = "" } = data;
      document.title = shopName ? `${shopName}-会员注册` : "会员注册";
    });
  },

  methods: {
    $dateFormat(date, formatArg) {
      let format = formatArg;
      const newDate = new Date(date);
      const object = {
        "M+": newDate.getMonth() + 1,
        "d+": newDate.getDate(),
        "h+": newDate.getHours(),
        "m+": newDate.getMinutes(),
        "s+": newDate.getSeconds(),
        "q+": Math.floor((newDate.getMonth() + 3) / 3),
        S: newDate.getMilliseconds()
      };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, `${newDate.getFullYear()}`.substr(4 - RegExp.$1.length));
      }
      for (const key in object) {
        if (new RegExp(`(${key})`).test(format)) {
          // eslint-disable-next-line max-len
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? object[key]
              : `00${object[key]}`.substr(`${object[key]}`.length),
          );
        }
      }
      return format;
    },

    // 显示/隐藏生日选择面板
    birthdayToggle(visible) {
      if (visible) {
        this.birthdayVisible = true;
      } else {
        this.birthdayVisible = false;
      }
    },

    // 验证是否可以点击注册按钮
    verifyRegDisable() {
      const { name, phone, captcha } = this;
      if (
        name === ""
        || phone === ""
        || (phone && phone.length !== 11)
        || captcha === ""
        || (captcha && captcha.length !== 4)
      ) {
        this.regVipDisable = true;
      } else {
        this.regVipDisable = false;
      }
    },

    // 修改生日
    birthdayChange(value) {
      this.birthday2 = this.$dateFormat(value, "yyyy-MM-dd");
      this.birthdayToggle(false);
    },

    // 获取验证码
    getCaptcha() {
      const { phone, shopId } = this;
      if (phone === "") {
        Notify({ type: "danger", message: "请输入手机号" });
        this.phoneFocus = true;
        return;
      }
      if (phone.length !== 11) {
        Notify({ type: "danger", message: "请输入正确的手机号" });
        this.phoneFocus = true;
        return;
      }

      this.$store.dispatch("vip/getSms", { phone, shop_id: shopId }).then((res) => {
        const { code } = res;
        if (code === 0) {
          this.captchaLoading = true;
          timer = setInterval(() => {
            this.captchaCount = this.captchaCount - 1;
            if (this.captchaCount <= 0) {
              clearInterval(timer);
              this.captchaCount = 60;
              this.captchaLoading = false;
            }
          }, 1000);
        }
      });
    },

    // 注册会员
    regVip() {
      const {
        shopId, name, phone, sex, birthday, birthday2, captcha, regVipDisable
      } = this;

      console.log("shopId", shopId);

      if (regVipDisable) {
        return;
      }

      this.$store.dispatch("vip/insertVip", {
        sex,
        name,
        phone,
        shop_id: shopId,
        captcha,
        birthday: birthday2 ? this.$dateFormat(birthday, "yyyy-MM-dd") : ""
      }).then((res) => {
        const { code } = res;
        if (code === 0) {
          this.$router.push(`/vip/result?s=${shopId}`);
        }
      });
    }
  }
};
